import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/types'
import usePriceAppointmentPhone from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/composables/usePriceAppointmentPhone'
import useMedflexPrices from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/composables/useMedflexPrices'
import usePriceCatalog from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/composables/usePriceCatalog'

/**
 * Общая оркестрация секции цен для Desktop/Mobile shells.
 */
export default function usePriceSection() {
  const { context }: ContextStore = useContextStore()
  const { appointmentPhone } = usePriceAppointmentPhone(context.lpu)
  const medflex = useMedflexPrices()
  const catalog = usePriceCatalog({
    serviceCategories: medflex.serviceCategories,
    serviceClasses: medflex.serviceClasses,
    selectedCategoryName: medflex.selectedCategoryName,
  })

  return {
    context,
    appointmentPhone,
    ...medflex,
    ...catalog,
  }
}
